import { DarePlatform } from 'root/src/shared/@types/platforms';
import { isViewershipPlatform } from 'root/src/shared/platforms/guards/platform.guards';
// Turns the publisher's breakpoints into the ranges creators actually experience. A breakpoint is
// an upper bound in calculateMaxDares (`count > breakpoint` moves you up a tier), so tier N starts
// one above breakpoint N-1, and anything above the last breakpoint gets every dare.
export const buildRequirementTiers = (breakpoints) => {
    const sorted = [...(breakpoints !== null && breakpoints !== void 0 ? breakpoints : [])].sort((a, b) => a.viewershipCount - b.viewershipCount);
    const highest = sorted[sorted.length - 1];
    if (!highest) {
        return [];
    }
    const bounded = sorted.map((breakpoint, index) => ({
        from: index === 0 ? 0 : sorted[index - 1].viewershipCount + 1,
        to: breakpoint.viewershipCount,
        maxDares: breakpoint.maxDares,
    }));
    return [...bounded, { from: highest.viewershipCount + 1, maxDares: Infinity }];
};
// The viewership a creator needs before any dare opens up, or null when the drop lets everyone in.
// Publishers express "not eligible" as a leading tier worth 0 dares, so the bar is the bottom of the
// first tier that grants at least one.
export const getMinimumViewership = (breakpoints) => {
    const firstEarning = buildRequirementTiers(breakpoints).find(tier => tier.maxDares > 0);
    if (!firstEarning || firstEarning.from === 0) {
        return null;
    }
    return firstEarning.from;
};
// What the numbers on each platform measure, for the unit next to them.
export const VIEWERSHIP_UNIT = {
    [DarePlatform.Twitch]: 'average CCV',
    [DarePlatform.YouTube]: 'average views',
    [DarePlatform.YouTubeShorts]: 'average views',
    [DarePlatform.TikTok]: 'average views',
};
// The bare metric, for prose that already says "you average": "You average 37 CCV on Twitch".
export const VIEWERSHIP_METRIC = {
    [DarePlatform.Twitch]: 'CCV',
    [DarePlatform.YouTube]: 'views',
    [DarePlatform.YouTubeShorts]: 'views',
    [DarePlatform.TikTok]: 'views',
};
// Platforms this drop actually gates on, in a stable display order. Reads the breakpoints rather
// than the dares: the breakpoints are what the publisher configured as the requirement, and a
// platform with none of them imposes no bar worth showing.
const PLATFORM_ORDER = [
    DarePlatform.Twitch,
    DarePlatform.YouTube,
    DarePlatform.YouTubeShorts,
    DarePlatform.TikTok,
];
export const getRequirementPlatforms = (breakpoints) => {
    if (!breakpoints) {
        return [];
    }
    return PLATFORM_ORDER.filter(platform => { var _a, _b; return ((_b = (_a = breakpoints[platform]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0; })
        .filter(isViewershipPlatform);
};
